module.exports = __webpack_public_path__ + "img/logout.70c85942.svg";